module.exports = __webpack_public_path__ + "img/temperature-half.d54f08c3.svg";